module.exports = __webpack_public_path__ + "img/Redem-light.82273760.png";